import * as React from 'react';
/** @hidden */
export var DayViewGroupRowContent = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "k-scheduler-cell k-side-cell", "data-range-index": props.rangeIndex }),
        props.children));
};
//# sourceMappingURL=DayViewGroupRowContent.js.map